<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mb-0" v-if="rodada">
          <v-card-title class="pb-0" primary-title>
            <v-layout>
              <v-flex>
                <div>
                  <h3 class="text--primary">{{ rodada.nome }}</h3>
                </div>
              </v-flex>
              <v-flex text-xs-right class="no-print"> </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <div style="padding-bottom: 6px"></div>
                <span
                  ><b>{{ rodada.local }}</b></span
                >
                <div style="padding-bottom: 6px"></div>
                <span
                  ><b>{{ rodada.cidade_estado }}</b></span
                >
                <div style="padding-bottom: 6px"></div>
                <span>{{ rodada.data_inicio }} à {{ rodada.data_fim }}</span>
                <div style="padding-bottom: 6px"></div>
                <span>Realização</span><br />
                <span
                  ><b>{{ rodada.administrador_nome }}</b></span
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "DadosRodada",
  data() {
    return {
      rodada: null,
    };
  },
  mounted() {
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
  },
};
</script>

<style scoped>
/*  */
</style>
